<!--选择在职员工--->
<template>
    <div class="inheritEmployess-list">
        <van-search class="search-button" v-model="searchStr" @search="onLoad" @clear="selClear" placeholder="请输入搜索关键词"
            left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
        </van-search>
        <div v-if="storeInfoList.length>0" class="child-list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
                    <div class="child-list-div" v-for="(item, index) in storeInfoList" @click="toConfirm(item)"
                        :key="index+item.id">
                        <div class="child-contact-list flex-row">
                            <div class="child-img-div flex-col">
                                <img class="child-img" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                            </div>
                            <div class="child-contact-txt-div flex-col justify-between">
                                <span class="child-contact-txt">{{item.name}}</span>
                            </div>
                            <!-- <img
                class="child-contact-label"
                referrerpolicy="no-referrer"
                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/node.png"
              /> -->
                        </div>
                        <div class="child-section flex-col"></div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <div v-else class="flex flex-col flex-y-center">
            <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                class="empty-icon" alt="" />
            <div class="empty-txt">暂无员工～</div>
        </div>
    </div>
</template>
<script>
import request from "@/utils/request";
import { Dialog, Toast } from "vant";

export default {
    name: "inheritEmployeesList",
    data() {
        return {
            storeInfoList: [],
            checkedEmployeesList: [],  // photolist checkContactList
            photoNamelist: [],
            searchStr: "",
            page: 1,
            total: 0,
            loading: false,
            finished: false,
            refreshing: false,
        };
    },
    mounted() {
        this.checkedEmployeesList = JSON.parse(this.$route.query.checkedEmployeesList);
        if (this.checkedEmployeesList.photolist) {
            this.checkedEmployeesList.photolist.map(n => {
                this.photoNamelist.push(n.name)
            })
        }
        this.onLoad();
    },

    methods: {
        onLoad() {
            request({
                url: `/workEmployee/getEmpByStoreId?mobile=${this.searchStr}`,
                method: "get",
            })
                .then((res) => {
                    this.storeInfoList = res.data;
                })
                .finally(() => {
                    this.loading = false;
                    this.finished = true;
                });
        },
        selClear() {
            this.searchStr = ""
        },

        // 清空list数据
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            this.loading = true;
            this.storeInfoList = []
            this.refreshing = false;
            this.onLoad();
        },

        //确定保存
        toConfirm(val) {
            Dialog.confirm({
                title: '分配客户',
                message:
                    `确认将${JSON.stringify(this.photoNamelist)}客户和客户群分配给${val.name}？`,
            })
                .then(() => {
                    // on confirm
                    this.toSave(val);
                })
                .catch(() => {
                    // on cancel
                });

        },

        toSave(val)  //保存离职继承
        {
            var param = {
                empConlist: this.checkedEmployeesList.checkContactList,
                groupList: [],
                newEmployeeId: val.employeeId,
                newEmpwxUserId: val.wxUserId
            }

            request({
                url: `/transferCust/transferResCust`,
                method: "post",
                data: param,
            })
                .then((res) => {
                    //跳转成功页面
                    this.$router.push({ name: "allocatedSuccess", query: {} });
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                });
        }


    },
};
</script>

<style  lang="less" scoped>
.inheritEmployess-list {
    background-color: #ffffff;
}

.child-list-box {
    height: 82vh;
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
}

.child-allchecked {
    margin-top: 20px;
    margin-left: 30px;
}

.child-list-div {
    margin-top: 8px;
    margin-left: 30px;
    padding-bottom: 1px;
}

.child-contact-list {
    background-color: rgb(255 255 255);
    height: 132px;
}

.child-check-box {
    /* height: 35px; */
    margin-top: 60px;
    margin-left: 3px;
}

.child-img-div {
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    overflow: hidden;
    margin-left: 30px;
    margin-top: 30px;
}

.child-img {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 70px;
    height: 70px;
}

.child-contact-txt-div {
    width: 90px;
    height: 92px;
    margin-left: 30px;
    margin-top: 52px;
}

.child-contact-txt {
    width: 90px;
    height: 42px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
}

.child-contact-label {
    width: 32px;
    height: 32px;
    margin: 55px 0 0 384px;
}

.child-section {
    width: 506px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    margin: 2px 0 0 156px;
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}

:deep(.van-search__content) {
    padding-left: 0 !important;
}
:deep(.van-search) {
    /* background-color: #f5f6f7 !important; */
    padding: 30px 30px !important;
}
:deep(.van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 20px !important;
    margin-right: 0 !important;
}

:deep(.van-field__control) {
    font-size: 28px !important;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
</style>